import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (17.382 / 16);
  const localHeight = size * (16 / 16);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 17.382 16">
      <path
        d="M611.9,113.984l-.375-.269c-.021-.015-2.1-1.513-4.106-3.2-1.988-1.674-4.241-3.571-4.241-7.089,0-2.9,2.321-5.442,4.966-5.442a4.9,4.9,0,0,1,3.7,1.487,4.89,4.89,0,0,1,3.751-1.487c2.645,0,4.966,2.543,4.966,5.442,0,3.518-2.253,5.415-4.241,7.089s-4.027,3.181-4.048,3.2Z"
        transform="translate(-603.18 -97.984)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
